import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useListProducts } from '@/shared/hooks/api/product'
import {
  buildProductDisplayNameMap,
  getLlmChatSessionScopeDisplay,
} from '../llmChatSessionScopeLabel'

export function useLlmChatSessionScopeLabel(
  productId: string | null | undefined
) {
  const { t } = useTranslation('llmChat')
  const productsQuery = useListProducts()
  const noNameProductLabel = t('newChatWizard.productSelect.noName')

  const productDisplayNameMap = useMemo(
    () =>
      buildProductDisplayNameMap(productsQuery.data ?? [], noNameProductLabel),
    [noNameProductLabel, productsQuery.data]
  )

  const scope = useMemo(
    () =>
      getLlmChatSessionScopeDisplay({
        productId,
        productDisplayNameMap,
        productsLoaded: productsQuery.isSuccess,
        translate: t,
      }),
    [productDisplayNameMap, productId, productsQuery.isSuccess, t]
  )

  const trimmedProductId = productId?.trim()
  const isScopeLoading =
    trimmedProductId !== undefined &&
    trimmedProductId !== null &&
    trimmedProductId.length > 0 &&
    !productsQuery.isSuccess

  return { scope, isScopeLoading }
}
